import SubmitCard from '@/components/card/submit-card-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import PropTypes from 'prop-types';
import getQuoteModuleApi from '@/api/get/company/quote-modules/get-quote-module';
import QuoteModuleForm from './quote-module-form';

/**
 * Quote module form wrapper component
 * @param {object}  root0 -
 * @param {object} root0.type -
 * @param {func} root0.submit -
 * @param {string} root0.moduleIdToEdit -
 * @param {string} root0.companyId -
 * @param {func} root0.onClose -
 * @returns {JSX.Element} - form component
 */
const QuoteModuleFormWrapper = ({
  type,
  submit,
  moduleIdToEdit,
  onClose,
  companyId,
}) => (
  <FormWrapper
    onSubmit={submit}
    defaultValues={async () => {
      if (type === 'edit' && moduleIdToEdit) {
        const module = await getQuoteModuleApi(companyId, moduleIdToEdit);
        delete module.data.id;
        return module.data;
      }
      return { options: [{ defaultOption: true, value: 'Other' }] };
    }}
  >
    <QuoteModuleForm />
    <SubmitCard
      padding="0"
      primaryButtonTitle="Save"
      primaryButtonType="submit"
      primaryButtonWidth="112px"
      primaryPermission={['quoteModule.create', 'quoteModule.update']}
      secondaryButtonType="button"
      secondaryButtonWidth="112px"
      isLoading={false}
      secondaryButtonTitle="Cancel"
      submitClickSecondary={() => {
        onClose();
      }}
    />
  </FormWrapper>
);

QuoteModuleFormWrapper.propTypes = {
  type: PropTypes.string,
  submit: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  moduleIdToEdit: PropTypes.string,
  companyId: PropTypes.string,
};

QuoteModuleFormWrapper.defaultProps = {
  type: '',
  companyId: '',
  moduleIdToEdit: '',
  submit: () => {},
};

export default QuoteModuleFormWrapper;
